module.exports = "/_next/static/images/c2cbe6b5e66811b8660d1d5265d66916-payment_boleto.png";